<template>
    <basic-container>
      <avue-crud v-if="reWrite"
                 :option="option"
                 :table-loading="loading"
                 :data="data"
                 :page.sync="page"
                 :permission="permissionList"
                 :before-open="beforeOpen"
                 v-model="form"
                 ref="crud"
                 @row-update="rowUpdate"
                 @row-save="rowSave"
                 @row-del="rowDel"
                 @search-change="searchChange"
                 @search-reset="searchReset"
                 @selection-change="selectionChange"
                 @current-change="currentChange"
                 @size-change="sizeChange"
                 @on-load="onLoad"
                 @refresh-change="onLoad"
      >
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.examinereport_delete"
                           @click="handleDelete">删 除

                </el-button>
            </template>
            <template slot="averageScore" slot-scope="scope">
                            <span :style="scope.row.averageScore<scope.row.baseScore?'color:#DD001B':'color:#ACF227'">{{ scope.row.averageScore }}</span>
            </template>
            <template slot="menu" slot-scope="scope">
              <el-button
                  type="text"
                   size="mini"
                   icon="el-icon-view"
                   @click="handleViewInspectPlan(scope.row)"
                >查看</el-button>
                <el-button
                  type="text"
                   size="mini"
                   icon="el-icon-warning-outline"
                   @click="openUnqualified(scope.row)"
                >不合格项</el-button>
                <el-button
                  v-if="scope.row.averageScore<scope.row.baseScore"
                  type="text"
                   size="mini"
                   icon="el-icon-bell"
                   @click="openNoticeDialog(scope.row)"
                >整改通知</el-button>
              <el-button
                v-if="permissionList.exportBtn"
                type="text"
                size="mini"
                icon="el-icon-bell"
                @click="openExportDialog(scope.row)"
              >导出</el-button>
            </template>
        </avue-crud>
        <el-dialog
          title="新增"
          width="50%"
          append-to-body
          :visible.sync="noticeDialog"
          :modal-append-to-body="false"
        >
        <avue-form
                ref="complaintForm"
                :option="noticeFormOption"
                v-model="noticeForm"
                v-if="noticeDialog"
                @submit="noticeSubmit"
               >

                </avue-form>

    </el-dialog>
        <viewForm ref="viewDialog"></viewForm>
        <unqualified ref="unqualified"></unqualified>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/crmedical/examine/examinereport";
    import { rectify }  from  "@/api/crmedical/examine/examinereportrectify";
    import {mapGetters} from "vuex";
    import {getProjectList} from "@/api/crmedical/project/project";
    import viewForm from "./examinereport-view-form";
    import unqualified from './examinereport-unqualified-form';
    import {getToken} from '@/util/auth';
    import {noticeFormOption} from "./examinereportrectify-form-option"
    export default {
      components:{
        viewForm,
        unqualified
      },
        data() {
            return {
                noticeDialog:false,//整改通知弹窗
                noticeFormOption:noticeFormOption,
                noticeForm:{},
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                firstDisplayFlag:false,
                reWrite: false,
                tempProjectId: '',
                projectList:[],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    searchShow: true,
                    searchMenuSpan: 6,
                    border: true,
                    indexLabel:'序号',
                    index: true,
                    viewBtn: true,
                    selection: true,
                    align:'center',
                    dialogClickModal: false,
                    column: [
                      {
                                    label: "主键",
                                    prop: "id",
                                    editDisplay: false,
                                    addDisplay: false,
                                    viewDisplay: false,
                                    hide: true,
                                },
                                {
                                  label: "项目名称",
                                  prop: "projectId",
                                  editDisplay: false,
                                  type: 'tree',
                                  searchClearable:false,
                                  search: true,
                                  dicUrl: '/api/v4ward/project/getProjectList',
                                  props: { label: 'name', value: 'id' },
                                },
                      {
                        label: "任务名称",
                        prop: "taskMainName",
                      },
                      {
                        label: "考核类型",
                        prop: "type",
                        type: "select",
                        search: true,
                        dataType: 'number',
                        dicUrl: "/api/blade-system/dict/dictionary?code=examine_type",
                        dicData: [],
                        props: {
                          label: "dictValue",
                          value: "dictKey",
                        },
                        rules: [{
                          required: true,
                          message: "请输入考核类型",
                          trigger: "change"
                        }]
                      },
                      {
                        label: "填报人数",
                        prop: "fillCount",
                        rules: [{
                          required: true,
                          message: "请输入填报人数",
                          trigger: "change"
                        }]
                      },
                      {
                        label: "总分值",
                        prop: "totalScore",
                        rules: [{
                          required: true,
                          message: "请输入总分值",
                          trigger: "change"
                        }]
                      },
                      {
                        label: "平均分值",
                        prop: "averageScore",
                        slot:true,
                        rules: [{
                          required: true,
                          message: "请输入平均分值",
                          trigger: "change"
                        }]
                      },
                      {
                        label: "基准分值",
                        prop: "baseScore",
                        rules: [{
                          required: true,
                          message: "请输入基准分值",
                          trigger: "change"
                        }]
                      },
                      {
                        label: "报告状态",
                        prop: "reportStatus",
                        dataType: 'number',
                        dicUrl: "/api/blade-system/dict/dictionary?code=examine_report_status",
                        dicData: [],
                        props: {
                          label: "dictValue",
                          value: "dictKey",
                        },
                        rules: [{
                          required: true,
                          message: "请输入报告状态",
                          trigger: "change"
                        }]
                      },
                      {
                        label: "关联合同",
                        prop: "contractName",
                        maxlength: 30,
                        showWordLimit: true,
                        overHidden: true,
                      },
                      {
                        label: "合同编号",
                        search: true,
                        maxlength: 30,
                        showWordLimit: true,
                        overHidden: true,
                        prop: "contractCode",
                      },
                      {
                        label: "任务批次号",
                        prop: "batchCode",
                        editDisplay: false,
                        viewDisplay: false,
                        hide: true,
                        rules: [{
                          required: true,
                          message: "请输入任务批次号",
                          trigger: "change"
                        }]
                      },
                      {
                        label: "考核开始时间",
                        prop: "startTime",
                        rules: [{
                          required: true,
                          message: "请输入考核开始时间",
                          trigger: "change"
                        }]
                      },
                      {
                        label: "考核结束时间",
                        prop: "endTime",
                        rules: [{
                          required: true,
                          message: "请输入考核结束时间",
                          trigger: "change"
                        }]
                      },
                    ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.examinereport_add, false),
                    viewBtn: this.vaildData(this.permission.examinereport_view, false),
                    delBtn: this.vaildData(this.permission.examinereport_delete, false),
                    editBtn: this.vaildData(this.permission.examinereport_edit, false),
                    exportBtn: this.vaildData(this.permission.examinereport_export, true)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        activated(){
          // console.log(this.$refs.crud.$refs.table.doLayout());
        },
        created() {
          //加载列表

          getProjectList({}).then((res) => {
            this.projectList = res.data;
            if (this.projectList.length > 0) {
              this.query.projectId = this.projectList[0].id;
              this.tempProjectId = this.projectList[0].id;
            }
            this.$nextTick(() => {
              this.reWrite = true;
            });
            setTimeout(()=>{
              window.onresize = ()=>{
                console.log(this.$refs.crud.$refs.table.doLayout());
              }
            })
            //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
            this.firstDisplayFlag = true;
          });
        },
        activated(){
          window.onresize = ()=>{
            console.log(this.$refs.crud.$refs.table.doLayout());
          }
          console.log(this.$refs.crud.$refs.table.doLayout());
        },
        activated(){
          console.log(this.$refs.crud.$refs.table.doLayout());
        },
        methods: {

        //导出
          openExportDialog(row){
            this.$confirm("是否导出报告数据?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                  }).then(() => {
                    //导出报告

                    window.open(`/api/v4ward/examine/report/deviceExport?${this.website.tokenHeader}=${getToken()}&projectId=${row.projectId}&id=${row.id}&taskMainName=${row.taskMainName}`);

                  });
          },

          // 整改提交
          noticeSubmit(form,done){
              form.projectId =  this.noticeForm.projectId;
              form.id = this.noticeForm.id;

              rectify(form).then(res=>{
                if(res.success){
                  this.noticeDialog = false;
                  this.onLoad();
                  this.$message({
                      message: res.msg,
                      type: 'success'
                  });
                }
              })
              done()
          },
          // 打开整改通知弹窗
          openNoticeDialog(row){
            console.log(row)
            this.noticeForm={};
            this.noticeForm.projectId = row.projectId;
            this.noticeForm.id = row.id;
            this.noticeDialog = true;
          },
          // 打开不合格项
          openUnqualified(row){
            this.$refs.unqualified.setdata(row);
          },
          // 查看
          handleViewInspectPlan(row){
              this.$refs.viewDialog.setdata(row);
          },
          getProjectNameById(projectId) {
            let projectName = '';
            this.projectList.forEach(function (value, index, array) {
              if (value.id === projectId) {
                projectName = value.name;
                return;
              }
            });
            return projectName;
          },

            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
          beforeOpen(done, type) {
            if (["edit", "view"].includes(type)) {
              getDetail({id:this.form.id}).then(({data}) => {
                this.form = data;
              });
            } else {
              setTimeout(()=>{
                this.form.projectId = this.query.projectId;
              },0)
            }
            done();
          },
          searchReset() {
            this.query.name = '';
            this.query.contractCode = '';
            this.query.type = '';
            this.firstDisplayFlag = true;
            this.onLoad();
          },
          searchChange(params, done) {
            this.query = params;
            this.page.currentPage = 1;
            this.onLoad();
            done();
          },
          selectionChange(list) {
            this.selectionList = list;
          },
          selectionClear() {
            this.selectionList = [];
            this.$refs.crud.toggleSelection();
          },
          currentChange(currentPage) {
            this.page.currentPage = currentPage;
          },
          sizeChange(pageSize) {
            this.page.pageSize = pageSize;
          },
          onLoad(page) {
            page = page || this.page;
            this.loading = true;
            //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
            if (!this.query.projectId ) {
              this.query.projectId = this.tempProjectId;
            }
            getList(
              Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
            ).then(({data}) => {
              this.page.total = data.total;
              this.data = data.records;
              this.loading = false;
              this.selectionClear();
              if (this.firstDisplayFlag) {
                let ent = document.querySelector('input[placeholder="项目名称"]');
                ent.value = this.getProjectNameById(this.query.projectId);
                this.tempProjectId = this.query.projectId
                //关闭默然显示，重刷页面时才开启默认显示
                this.firstDisplayFlag = false;
              }
            });
          }
        }
    };
</script>

<style>
</style>
